import React from "react";
import "./SSI_table_holder.css"; // Optional: for custom styles

const SSI_table_holder = () => {
  const data = [
    {
      nature: "External and in-transit damage/loss/wrong article delivered",
      refund:
        "Claim for refund shall be lower of: (i) INR 5000 (Rupees Five Thousand); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature: "Internal damage / missing article delivered",
      refund:
        "Claim for refund shall be lower of: (i) INR 2500 (Rupees Two Thousand Five Hundred); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature:
        "External damage/ wrong article delivered which have been OTP verified",
      refund: "No claim for refund shall be entertained.",
    },
    {
      nature:
        "External damage/ wrong articles delivered which are not OTP verified and invoice for such delivery is available",
      refund:
        "Claim for refund shall be lower of: (i) INR 5000 (Rupees Five Thousand); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature:
        "External damage/ wrong articles delivered which are not OTP verified and invoice for such delivery is not available",
      refund:
        "Claim for refund shall be lower of: (i) INR 500 (Rupees Five Hundred); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature:
        "Internal damage/ missing articles delivered for which invoice is available",
      refund:
        "Claim for refund shall be lower of: (i) INR 2500 (Rupees Two Thousand Five Hundred); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature:
        "Internal damage/ missing articles delivered for which invoice is not available",
      refund:
        "Claim for refund shall be lower of: (i) INR 500 (Rupees Five Hundred); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature:
        "Lost/ in-transit damage to articles for which invoice is available",
      refund:
        "Claim for refund shall be lower of: (i) INR 5000 (Rupees Five Thousand); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature:
        "Lost/ in-transit damage to articles for which invoice is not available",
      refund:
        "Claim for refund shall be lower of: (i) INR 500 (Rupees Five Hundred); or (ii) Value of the articles declared at the time of booking.",
    },
    {
      nature: "Articles sent but form part of Prohibited Items",
      refund: "No claim for refund shall be entertained.",
    },
  ];

  return (
    <section className="SSI_table_holder">
      <div className="table-responsive ">
        <table className="claim-table">
          <thead>
            <tr>
              <th>Nature of Claim</th>
              <th>Maximum Compensation/Refund</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td>{row.nature}</td>
                <td>{row.refund}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default SSI_table_holder;
